import { render, staticRenderFns } from "./PrinorTabs-Nav.vue?vue&type=template&id=d0157cf4&scoped=true&"
import script from "./PrinorTabs-Nav.vue?vue&type=script&lang=js&"
export * from "./PrinorTabs-Nav.vue?vue&type=script&lang=js&"
import style0 from "./PrinorTabs-Nav.vue?vue&type=style&index=0&id=d0157cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0157cf4",
  null
  
)

export default component.exports